<template>
  <div class="box">
      <!-- projects -->
      <div>
        <div class="box-title flex between middle">
          <div class="flex between middle">
            Projetos (Clientes): {{ account.used_limits.projects | number }} / {{ account.plan_limits.projects | number }} 
            <div v-if="account.plan_limits.projects > 0" style="margin-left: 16px">Precisa de mais projetos (Clientes)? <router-link :to="{ name: 'SubscriptionRedirectParam', params: { flow: 'cliente' } }">Faça Upgrade</router-link></div>
            <div v-if="account.plan_limits.projects === 0" style="margin-left: 16px">Precisa criar contas para seus (Clientes)? Assine o plano Agência <router-link :to="{ name: 'SubscriptionRedirectParam', params: {} }">Faça Upgrade</router-link></div>
          </div>
          <div class="">
            <div class="button primary" :class="{ 'disable': alertLimit }" @click="openModalCreate()">
              NOVO
            </div>
          </div>
        </div>
        <div class="box-content">
          <div v-if="!loading" class="flex w100 column">
              <ul class="list-projects">
                <li v-for="(proj, index) in projects" :key="index">
                  <div class="flex middle">
                    <div class="flex-1 flex column">
                      <div>{{ proj.name }}</div>
                      <div>
                        Status: <span>{{ _decodeStatus(proj.status) }}</span>
                      </div>
                    </div>
                    <div class="flex-1">
                      <div class="flex end actions">
                        <div
                          v-if="['ACTIVE', 'ONBOARDING'].includes(proj.status)"
                          class="button primary"
                          @click="accessProject(proj)"
                        >
                          ACESSAR
                        </div>
                        <div
                          class="button secondary"
                          @click="editProjectSelect(proj)"
                        >
                          EDITAR
                        </div>
                        <div
                          v-if="false"
                          class="button secondary"
                          @click="editProjectSelect(proj)"
                        >
                          LIMPAR DADOS
                        </div>
                        <div
                          class="button secondary"
                          @click="
                            selectedProjectId = proj.id;
                            showModalDelete = true;
                          "
                        >
                          REMOVER
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-if="projects && projects.length === 0" class="flex w100">
                <p>Você não tem nenhum projeto (Cliente) criado, crie seu primeiro e tenha relatóris totalmente individuais por contas!</p>
              </div>
          </div>
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
      </div>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar o projeto"
      @cancel="
        showModalDelete = false;
        selectedProject = null;
      "
      @accept="deleteProject(selectedProject)"
    ></modal-confirm>
    <!-- modal new user / update -->
    <modal
      :title="modalTitle"
      :show="showModalCreateOrUpdate"
      @close="cleanProjectInfo()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form autocomplete="off" class="w100">
            <div class="flex-1 w100">
              <label>Nome</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newProject.name"
                autocomplete="off"
              />
            </div>
            <div class="flex-1 w100 margin-top-s">
            <!-- Modelo da Operação -->
            <label>
              Modelo da operação
            </label>
            <select class="input" v-model="newProject.business_type">
              <option value="">Selecionar</option>
              <option v-for="(f, index) in listOperation" :key="index" :value="f" :selected="f === newProject.business_type">
                {{ f }}
              </option>
            </select>
            </div>
          </form>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrUpdate()">CRIAR</div>
          </div>
        </div>
      </div>
    </modal>
    </div>
</template>

<script>

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

import { mapState } from "vuex";

import {
  listProject,
  createProject,
  updateProject,
  deleteProject,
} from "@/services/manager";

import { Account } from "@/services/account";


export default {
  name: "config-project",
  components: {
    Modal,
    ModalConfirm,
  },
  data() {
    return {
      loading: false,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedProjectId: null,
      newProject: {
        name: '',
        business_type: '',
      },
      listOperation: [
        'INFOPRODUTO',
        'DROPSHIPPING',
        'E-COMMERCE',
        'PLR',
        'SAAS',
        'LANÇAMENTO',
        'OUTROS'
      ],
      projects: [],
    };
  },
  mounted() {
    this.getProjects()
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    modalTitle() {
      if (this.newProject.id) {
        return 'Editar Projeto'
      }

      return 'Criar Projeto'
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.projects <= this.account.used_limits.projects) {
        return true
      }

      return false
    },
  },
  methods: {
    _decodeStatus(status) {
      var _m = {
        'ACTIVE': 'Ativa',
      }

      return _m[status] || status
    },
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de projetos do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      
      this.showModalCreateOrUpdate = true
    },
    accessProject(acc) {
      this.$store.dispatch("auth", { account: acc.id });
      Account().then((result) => {
        this.$store.dispatch("setAccount", result);
        this.$router.push({ name: "Home" });
      })
      .catch(() => {
        this.$toast.error({
          title:'Erro',
          message:'Ocorreu algum problema'
        })
      });
    },
    cleanProjectInfo() {
      this.newProject = {
        name: ''
      }

      this.showModalCreateOrUpdate = false
    },
    editProjectSelect(proj) {
      this.newProject = proj
      this.showModalCreateOrUpdate = true

    },
    saveOrUpdate() {
      this.showModalCreateOrUpdate = false

      if (this.newProject.id) {
        this.updateProject(this.newProject)
      } else {
        this.createProject(this.newProject)
      }
      
    },
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    getProjects() {
      this.loading = true
      listProject()
        .then((result) => {
          this.projects = result
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu um problema ao buscar dados'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    createProject(proj) {
      if (!proj.name || !proj.business_type) {
        this.$toast.error({
          title:'Erro',
          message:'Preencha um nome para criar um projeto'
        })
        
        return
      }

      let params = {
        name: proj.name,
        business_type: proj.business_type,
      }
      createProject(params)
        .then((result) => {
          this.$toast.success({
            title:'Sucesso',
            message:'Projeto criado com sucesso'
          })
          this.projects.push(result)
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Erro ao criar projeto'
          })
        })
    },
    updateProject(proj) {
      let params = {
        name: proj.name,
        business_type: proj.business_type,
      }
      updateProject(proj.id, params)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Projeto editado com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu um problema ao editar projeto'
          })
        })
    },
    cleanProject(proj) {
      console.log('proj', proj)
    },
    deleteProject() {
      deleteProject(this.selectedProjectId)
      .then(() => {
        this.projects = this.projects.filter(p => p.id !== this.selectedProjectId)
      })
      .catch(() => {
        this.$toast.error({
          title:'Erro',
          message:'Ocorreu um problema ao deletar projeto'
        })
      })
      .finally(() => {
        this.selectedProjectId = null
        this.showModalDelete = false
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.account {
  padding: 16px;
  border-right: 1px solid #c2c2c235;
}

.subscription {
  padding: 16px;
  ul {
    padding-left: 15px;
    li {
      // list-style-type: none;
      padding-top: 8px;
      padding-bottom: 8px;
      margin-bottom: 8px;
    }
  }
}

.list-projects {
  width: 100%;
  li {
    list-style-type: none;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #c2c2c258;
  }
}

.actions {
  > div {
    margin-left: 4px;
  }
}

.disable {
  background: #c2c2c2 !important;
}

</style>
